/**
 * Input Schema of TypeWebhook
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {TypeWebhook} from '@/model/resource/TypeWebhook'

/* TODO: review generated schema */
export class InputTypeWebhookSchema extends Schema {
  readonly name = 'InputTypeWebhook'

  readonly fieldSet: FieldSet<TypeWebhook> = {
    nome: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
  }
}
